/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_da1e7561{display:inline-block}\n"}]);
export const root = "root_da1e7561";